export interface IGetMembershipStatusResponse {
  status: UpdateMembershipStatus[] | 'error';
  error?: {
    message: string;
  };
}

export enum UpdateMembershipStatus {
  INITIALIZED = 'INITIALIZED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
}

export enum AutopayStatus {
  ENROLLED = 'ENROLLED',
  NOT_ENROLLED = 'NOT_ENROLLED',
}

export enum CommunicationPreference {
  PAPERLESS = 'PAPERLESS',
  PRINT = 'PRINT',
}
